import { gql } from "@apollo/client";

export const PAGE_SIZE = 30;

export const FETCH_CERTIFICATES = gql`
  query Certificates(
    $offset: Int
    $limit: Int
    $q: String
    $certificateTypes: [String]
    $country: String
    $productIds: [ID]
    $expiryStatus: String
  ) {
    certificates(
      offset: $offset
      limit: $limit
      q: $q
      certificateTypes: $certificateTypes
      country: $country
      productIds: $productIds
      expiryStatus: $expiryStatus
    ) {
      total
      results {
        id
        isActive
        certificateType
        title
        certificateNumber
        country
        issuer
        issuedDate
        expiryDate
        qrCodeExpireDate
        validityMonths
        validUntil
        expiryStatus
        fileUrls
        products {
          id
          imageUrls {
            id
            url(width: 90)
          }
          number
          name
          version
          countryCodeOfOrigin
        }
      }
    }
  }
`;

export const FETCH_E_FILING_COLLECTION = gql`
  query FETCH_E_FILING_COLLECTION($refresh: Boolean) {
    eFilingExportCollection(refresh: $refresh)
    eFilingGetTokenExpiration
  }
`;

export const FETCH_PRODUCTS_FOR_CERTIFICATE_IMAGES = gql`
  query FETCH_PRODUCTS_FOR_CERTIFICATE_IMAGES($ids: [ID]) {
    products(ids: $ids) {
      results {
        id
        images: computedImages(size: "600x600") {
          id
          url
        }
      }
    }
  }
`;

export const CREATE_CERTIFICATE = gql`
  mutation CreateCertificate(
    $certificateType: String!
    $isActive: Boolean
    $title: String!
    $issuedDate: Date!
    $certificateNumber: String
    $issuer: String
    $country: String
    $imageUrls: [String]
    $validityMonths: Int
    $validUntil: Date
    $productIds: [ID]
    $testReportIds: [ID]
    $fileUrls: [String]
  ) {
    createCertificate(
      certificateType: $certificateType
      isActive: $isActive
      title: $title
      issuedDate: $issuedDate
      certificateNumber: $certificateNumber
      issuer: $issuer
      country: $country
      imageUrls: $imageUrls
      validityMonths: $validityMonths
      validUntil: $validUntil
      productIds: $productIds
      testReportIds: $testReportIds
      fileUrls: $fileUrls
    ) {
      certificate {
        id
      }
    }
  }
`;

export const FETCH_CERTIFICATE = gql`
  query FETCH_CERTIFICATE($id: ID!) {
    certificate(id: $id) {
      id
      isActive
      certificateType
      title
      certificateNumber
      issuer
      country
      imageUrls
      issuedDate
      validityMonths
      validUntil
      qrCodeExpireDate
      fileUrls
      products {
        id
        number
        name
        version
      }
      testReports {
        id
        title
        reportNumber
        issuer
        issuedDate
        standards {
          id
          name
        }
      }
    }
  }
`;

export const UPDATE_CERTIFICATE = gql`
  mutation UpdateCertificate(
    $id: ID!
    $certificateType: String
    $isActive: Boolean
    $title: String
    $issuedDate: Date
    $certificateNumber: String
    $issuer: String
    $country: String
    $imageUrls: [String]
    $validityMonths: Int
    $validUntil: Date
    $qrCodeExpireDate: Date
    $productIds: [ID]
    $testReportIds: [ID]
    $fileUrls: [String]
  ) {
    updateCertificate(
      id: $id
      certificateType: $certificateType
      isActive: $isActive
      title: $title
      issuedDate: $issuedDate
      certificateNumber: $certificateNumber
      issuer: $issuer
      country: $country
      imageUrls: $imageUrls
      validityMonths: $validityMonths
      validUntil: $validUntil
      qrCodeExpireDate: $qrCodeExpireDate
      productIds: $productIds
      testReportIds: $testReportIds
      fileUrls: $fileUrls
    ) {
      certificate {
        id
      }
    }
  }
`;

export const DELETE_CERTIFICATE = gql`
  mutation DeleteCertificate($id: ID!) {
    deleteCertificate(id: $id) {
      id
    }
  }
`;

export const GENERATE_CPC_PDF = gql`
  mutation GenerateCpcPdf($input: GenerateCpcPdfInput!, $filename: String!) {
    generateCpcPdf(input: $input, filename: $filename) {
      fileUrl
    }
  }
`;

export const GENERATE_DOC_PDF = gql`
  mutation GenerateDocPdf($input: GenerateDocPdfInput!, $filename: String!) {
    generateDocPdf(input: $input, filename: $filename) {
      fileUrl
    }
  }
`;
